import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";

import {
  FETCH_FACTORING_COMPANY_REQUEST,
  FETCH_FACTORING_COMPANY_SUCCESS,
  FETCH_FACTORING_COMPANY_FAILURE
} from "../types";

const fetchFactoringCompany = id => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(
      createAction(FETCH_FACTORING_COMPANY_REQUEST)({
        id
      })
    );
    const response = await api.groups.getFactoringCompany(id);
    const data = normalize(response, schema.factoringCompany);
    dispatch(addEntities(data.entities));
    dispatch(createAction(FETCH_FACTORING_COMPANY_SUCCESS)({ id }));
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_FACTORING_COMPANY_FAILURE)(err));
    throw err;
  }
};

export default fetchFactoringCompany;
